define.alias("shared/components/shared/social/tiktok-connection-status", "settings/components/shared/social/tiktok-connection-status");